import { Component, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Hotel } from '../../models/hotels/Hotel';
import { RecommendationsResponse } from '../../models/hotels/RecommendationsResponse';
import { HotelsFilters } from '../../models/filtermodels/HotelsFilters';
import { RecommendationService } from '../../services/recommendation.service';
import { TrafficsService } from '../../services/traffics.service';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import moment from 'moment';

@Component({
    selector: 'app-recommendations',
    templateUrl: './recommendations.component.html',
    styleUrls: ['./recommendations.component.scss'],
    standalone: false
})
export class RecommendationsComponent implements OnInit, OnDestroy {
    @Input() data;
    @Input() realparams: ParamFilters;
    private unsubscribe$ = new Subject();
    hotels: Hotel[];
    loading = signal<boolean>(true);
    desktopTemplate: string = 'xl';
    recommendationResponse: RecommendationsResponse;
    constructor(
        private recommendationService: RecommendationService,
        private trafficsService: TrafficsService,
        protected mediaObserver: BreakpointObserver
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
    }

    ngOnInit(): void {
        this.hotels = [];
        this.getrecommendations();
    }

    async getrecommendations() {
        // console.log(this.realparams.reisendeResult.adults)
        let tmp_childrens = '';
        if (this.realparams?.reisendeResult?.children?.length > 0) {
            for (let i = 0; i < this.realparams.reisendeResult.children.length; i++) {
                tmp_childrens += this.realparams.reisendeResult.children[i].age + (i < this.realparams.reisendeResult.children.length - 1 ? ',' : '');
            }
        }
        if (this.data.giataId?.length > 0) {
            const filter: any = {
                giataId: this.data.giataId,
                productType: this.data.filtersData?.productType?.length > 0 ? this.data.filtersData?.productType : 'pauschal',
                adults: this.realparams?.reisendeResult?.adults ? this.realparams.reisendeResult.adults : '2',
                children: tmp_childrens,
            };
            // if (this.data?.filtersData?.searchDate?.length > 0) {
            //     filter.searchDate = this.data?.filtersData?.searchDate;
            // } else {
            //     if (moment(this.realparams?.reisezeitraumResult?.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            //         this.realparams.reisezeitraumResult.start = moment().format('YYYY-MM-DD');
            //     }
            //     if (moment(this.realparams?.reisezeitraumResult?.end).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
            //         this.realparams.reisezeitraumResult.end = moment(this.realparams.reisezeitraumResult.start).add(180, 'days').format('YYYY-MM-DD');
            //     }
            //     filter.duration = ',,' + this.realparams?.reisezeitraumResult?.minDuration + ',' + filter.maxDuration;
            //     filter.searchDate = this.realparams?.reisezeitraumResult?.start + ',' + this.realparams?.reisezeitraumResult?.end;
            // }
            this.recommendationService.request(filter, 'hotels/giataId/recommendations').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(result => {
                this.recommendationResponse = result as RecommendationsResponse;
                if (this.recommendationResponse?.recommendationList?.length > 0) {
                    let giatalist = '';
                    for (let i = 0; i < this.recommendationResponse.recommendationList.length && i < 11; i++) {
                        giatalist += this.recommendationResponse?.recommendationList[i].giataId + ',';
                    }
                    this.gettophotels(giatalist);
                } else {
                    this.loading.set(false);
                }
            });
        } else {
            this.loading.set(false);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async gettophotels(giatalist) {
        const filter = {} as HotelsFilters;
        filter.productType = this.data.productType?.length > 0 ? this.data.productType : 'pauschal';
        filter.productSubType = 'all';
        filter.adults = this.data.adults?.length > 0 ? this.data.adults : '2';
        filter.children = this.data.children?.length > 0 ? this.data.children : '';
        filter.rating = {
            source: 'holidaycheck',
            count: 0,
            recommendation: 0,
            overall: 0,
        };

        if (this.data?.filtersData?.searchDate?.length > 0) {
            filter.searchDate = this.data?.filtersData?.searchDate;
        } else {
            if (moment(this.realparams?.reisezeitraumResult?.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.realparams.reisezeitraumResult.start = moment().format('YYYY-MM-DD');
            }
            if (moment(this.realparams?.reisezeitraumResult?.end).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.realparams.reisezeitraumResult.end = moment(this.realparams.reisezeitraumResult.start).add(180, 'days').format('YYYY-MM-DD');
            }
            filter.duration = ',,' + this.realparams?.reisezeitraumResult?.minDuration + ',' + filter.maxDuration;
            filter.searchDate = this.realparams?.reisezeitraumResult?.start + ',' + this.realparams?.reisezeitraumResult?.end;
        }

        filter.giataIdList = giatalist;
        this.trafficsService.request(filter, 'hotels').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.hotelList?.length) {
                const hotels = [];
                const list = filter.giataIdList.split(',');
                for (let j = 0; j < list?.length; j++) {
                    for (let i = 0; i < res.hotelList.length; i++) {
                        if (res.hotelList[i].giata?.hotelId === list[j]) {
                            hotels.push(res.hotelList[i]);
                            i = res.hotelList.length;
                        }
                    }
                }
                this.hotels = JSON.parse(JSON.stringify(hotels));
            }
            this.loading.set(false);
        });
    }
}
